import React from "react"
import { TableColumn } from "client/components"
import { QidResultType } from "client/store"

import FormatedResult from "./formatedResult"

const Columns = () => {
    const cellMinWidth = "100px"
    const columns: TableColumn[] = [
        {
            field: "title",
            cellMinWidth: "250px",
        },
        {
            field: "sd",
            header: "SD",
            cellMinWidth,
            formatter: (data: QidResultType) => <FormatedResult data={data.sd} />,
        },
        {
            field: "su",
            header: "SU",
            cellMinWidth,
            formatter: (data: QidResultType) => <FormatedResult data={data.su} />,
        },
        {
            field: "dd",
            header: "DD",
            cellMinWidth,
            formatter: (data: QidResultType) => <FormatedResult data={data.dd} />,
        },
        {
            field: "du",
            header: "DU",
            cellMinWidth,
            formatter: (data: QidResultType) => <FormatedResult data={data.du} />,
        },
        {
            field: "ne",
            header: "NE",
            cellMinWidth,
            formatter: (data: QidResultType) => <FormatedResult data={data.ne} />,
        },
        {
            field: "np",
            header: "NP",
            cellMinWidth,
            formatter: (data: QidResultType) => <FormatedResult data={data.np} />,
        },
    ]

    return columns
}
export default Columns
